// extracted by mini-css-extract-plugin
export default {"modal":"ShortlistDetailModal_modal__be+OA","content":"ShortlistDetailModal_content__5R0mW","noStaffers":"ShortlistDetailModal_noStaffers__uelBo"};